import React from "react";
import {
  ShareIcon,
  MapIcon,
  ClipboardDocumentListIcon,
} from "@heroicons/react/24/outline";
import { ActiveTab } from "./types/pathway.types";

interface TabNavigationProps {
  activeTab: ActiveTab;
  setActiveTab: (tab: ActiveTab) => void;
}

export const TabNavigation: React.FC<TabNavigationProps> = ({
  activeTab,
  setActiveTab,
}) => {
  return (
    <div className="border-b border-gray-200 dark:border-slate-600">
      <nav className="flex space-x-8 px-6">
        <button
          onClick={() => setActiveTab("direct-neighbor")}
          className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors flex items-center gap-2 ${
            activeTab === "direct-neighbor"
              ? "border-blue-500 text-blue-600 dark:text-blue-400"
              : "border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-slate-600"
          }`}
        >
          <ShareIcon className="h-5 w-5" />
          Direct Neighbor Graph
        </button>
        <button
          onClick={() => setActiveTab("k-shortest-paths")}
          className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors flex items-center gap-2 ${
            activeTab === "k-shortest-paths"
              ? "border-blue-500 text-blue-600 dark:text-blue-400"
              : "border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-slate-600"
          }`}
        >
          <MapIcon className="h-5 w-5" />
          K-Shortest Paths
        </button>
        <button
          onClick={() => setActiveTab("pathway-comparison")}
          className={`py-4 px-1 border-b-2 font-medium text-sm transition-colors flex items-center gap-2 ${
            activeTab === "pathway-comparison"
              ? "border-blue-500 text-blue-600 dark:text-blue-400"
              : "border-transparent text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-300 hover:border-gray-300 dark:hover:border-slate-600"
          }`}
        >
          <ClipboardDocumentListIcon className="h-5 w-5" />
          Pathway Comparison
        </button>
      </nav>
    </div>
  );
};
